<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Формирование аналитической справки</span>
      <a class="close" @click="$emit('close')">
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
              fill="#0033A0"
          />
        </svg>
      </a>
    </v-card-title>
    <v-card-text>
      <div class="rating-popup">
        <v-container>
          <v-row>
            <v-col cols="12">
              Название<h2>{{ config.content.title }}</h2>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>
    <v-card-actions style="margin-left: 32%">
      <v-btn outlined @click="$emit('close')">
        отмена
      </v-btn>
      <v-btn color="primary" @click="downloadReport" :disabled="loading">
        сформировать
      </v-btn>
    </v-card-actions>
    <LoaderDialog :show="loading"></LoaderDialog>
  </v-card>
</template>

<script>
import LoaderDialog from "../../elements/LoaderDialog";
import api from "@/modules/api";

export default {
  name: "AnalyticalReportConfigDialog",
  props: ['config'],
  components: { LoaderDialog },
  data: () => ({
    domain: 'analytical_report',
    format: 'docx',
    loading: false,
  }),
  methods: {
    async downloadReport() {
      try {
        this.loading = true
        const queryString = new URLSearchParams({
          format: this.format,
          config_id: this.config.id,
        })

        const response = (await api.get(`/reports/generate/${this.domain}/1?${queryString}`)).payload
        this.downloadTaskId = response.task_id
        await this.checkTaskStatus()
      } catch (error) {
        console.error('Error generating report:', error)
        alert('Ошибка при генерации отчета!')
        this.loading = false
      }
    },
    async checkTaskStatus() {
      try {
        const response = (await api.get(`/reports/status/${this.downloadTaskId}`)).payload
        if (response.status === 'SUCCESS') {
          await this.downloadFile()
        } else {
          setTimeout(this.checkTaskStatus, 2000)
        }
      } catch (error) {
        console.error('Error checking task status:', error)
        alert('Ошибка при проверке статуса задачи!')
        this.loading = false
      }
    },
    async downloadFile() {
      try {
        const blob = (await api.get(`/reports/download/${this.downloadTaskId}`, null, 'blob')).payload
        await this.$downloadBlob(blob, `${this.getReportTitle()}.${this.format}`)
      } catch (error) {
        console.error('Error downloading file:', error)
        alert('Ошибка при скачивании файла!')
      } finally {
        this.$emit('close')
        this.loading = false
      }
    },
    getReportTitle() {
      return this.config.content.title
    },
  },
  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mDate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mDate.toLocaleDateString('ru-RU', options)
    }
  },
};
</script>
